import React, { useEffect, useRef } from 'react';
import { createChart, LineSeries } from 'lightweight-charts';
import { observeChartSize } from '../utils/chartResize';
import './MacroSeriesChart.css';

function toChartData(bars) {
  return (bars || []).map((bar) => ({
    time: bar.time,
    value: Number(bar.value),
  }));
}

function MacroSeriesChart({ bars = [], color = '#1763A1', title = '', height = 220 }) {
  const containerRef = useRef(null);
  const chartRef = useRef(null);
  const seriesRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current || chartRef.current) return undefined;

    const chart = createChart(containerRef.current, {
      layout: { background: { color: '#FFFBF3' }, textColor: '#16244A' },
      grid: { vertLines: { color: '#EDE3CF' }, horzLines: { color: '#EDE3CF' } },
      rightPriceScale: { borderColor: '#E3D9C6' },
      timeScale: { borderColor: '#E3D9C6', timeVisible: true, secondsVisible: false },
      width: containerRef.current.clientWidth,
      height,
    });

    const series = chart.addSeries(LineSeries, {
      color,
      lineWidth: 2,
      priceLineVisible: false,
      lastValueVisible: true,
      title,
    });

    chartRef.current = chart;
    seriesRef.current = series;

    const disconnect = observeChartSize(containerRef.current, (width) => {
      chart.applyOptions({ width, height });
    });

    return () => {
      disconnect();
      chart.remove();
      chartRef.current = null;
      seriesRef.current = null;
    };
  }, [height, title, color]);

  useEffect(() => {
    seriesRef.current?.setData(toChartData(bars));
    chartRef.current?.timeScale().fitContent();
  }, [bars]);

  return (
    <div className="macro-series-chart">
      <div ref={containerRef} className="macro-series-chart-canvas" style={{ height }} />
    </div>
  );
}

export default MacroSeriesChart;
